import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollectionForm } from '../CollectionForm';
import * as S from './CollectionFormModal.styled';
import { Modal } from '@/components/UI/Modal';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { BookmarkCollection } from '@/features/BookmarkCollections/api';

interface CollectionFormModalProps {
  isOpen: boolean;
  mode?: 'create' | 'edit';
  collection?: BookmarkCollection;
  onClose: () => void;
  onSuccess: () => void;
  hasDescription?: boolean;
}

export const CollectionFormModal = ({
  hasDescription = true,
  isOpen,
  mode = 'create',
  collection,
  onClose,
  onSuccess,
}: CollectionFormModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth={600}>
      <S.Body>
        <S.Header>
          <S.Title>
            {mode === 'create'
              ? t('bookmark_collections.form_title')
              : t('bookmark_collections.edit_collection_dropdown')}
          </S.Title>
          <S.CloseButton onClick={onClose}>
            <CloseIcon name="close" width={20} height={20} />
          </S.CloseButton>
        </S.Header>

        <CollectionForm
          mode={mode}
          collection={collection}
          onSuccess={onSuccess}
          hasDescription={hasDescription}
        />
      </S.Body>
    </Modal>
  );
};
